export default __webpack_public_path__ + "static/hero-img-dc0a519647362b298c8ca30bd0b3a475.png";